import { render, staticRenderFns } from "./SBMessageCenter.vue?vue&type=template&id=6c803c6c"
import script from "./SBMessageCenter.vue?vue&type=script&lang=js"
export * from "./SBMessageCenter.vue?vue&type=script&lang=js"
import style0 from "./SBMessageCenter.vue?vue&type=style&index=0&id=6c803c6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports